export const variants = {
	default:
		"border-transparent bg-black text-white dark:bg-white dark:text-black",
	destructive: "border-transparent bg-destructive text-destructive-foreground",
	info: "border-transparent bg-info text-info-foreground",
	outline: "border border-input bg-background text-foreground",
	secondary: "border-transparent bg-secondary text-secondary-foreground",
	success: "border-transparent bg-success text-success-foreground",
	warning: "border-transparent bg-warning text-warning-foreground",
};
